import { connect } from 'react-redux';
import { compose } from 'recompose';
import onlyIf from '../../hocs/onlyIf';
import RelativeGuides from '../../components/handoff/RelativeGuides';
import { showRelativeGuides, getSelectedElementLayout, getHoveredElementLayout, isInHandoffMode, getPixelRatio, getElementLayoutForPercentage, } from '../../selectors/handoff';
function mapStateToProps(state) {
    if (!isInHandoffMode(state) || !showRelativeGuides(state)) {
        return {};
    }
    return {
        selectedElement: getSelectedElementLayout(state),
        hoveredElement: getHoveredElementLayout(state),
        relativeElement: getElementLayoutForPercentage(state),
        pixelRatio: getPixelRatio(state),
    };
}
export default compose(connect(mapStateToProps, null), onlyIf(function (props) { return props.hoveredElement; }))(RelativeGuides);
